import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface NameScreenProps {
  firstName: string;
  lastName: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function NameScreen({
  firstName,
  lastName,
  onChange,
  onNext,
  onBack
}: NameScreenProps) {
  const isValid = firstName.trim().length > 0 && lastName.trim().length > 0;
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-196">
      <div className="flex-1" data-id="element-197">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-198">
          What's your name?
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-199">
          Please enter your legal name as it appears on your ID.
        </p>

        <div className="space-y-6" data-id="element-200">
          <Input label="First Name" placeholder="e.g. Jane" value={firstName} onChange={e => onChange('firstName', e.target.value)} autoFocus data-id="element-201" />
          <Input label="Last Name" placeholder="e.g. Doe" value={lastName} onChange={e => onChange('lastName', e.target.value)} data-id="element-202" />
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-203">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-204">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-205">
          Continue
        </Button>
      </div>
    </div>;
}